import { Selectbutton } from '@/shared/ui/Selectbutton'
import type { OrgNewDraft } from '@/public/features/org/types'
import { HELP_TYPES } from '@/public/features/org/constants/orgNew'
import { StepHeadLarge } from '@/public/features/org/ui/orgNew/parts'

export function StepCardHelp({ draft }: { draft: OrgNewDraft }) {
  return (
    <section className="flex flex-col gap-8">
      <StepHeadLarge
        title="도움의 종류는 무엇인가요?"
        desc="제공 가능한 도움의 종류를 선택해주세요."
      />
      <div className="flex flex-col gap-3 [&>.ui-selectbutton]:w-full [&>.ui-selectbutton]:min-w-[150px]">
        {HELP_TYPES.map((h) => (
          <Selectbutton
            key={h.code}
            size="lg"
            label={h.label}
            isOn={draft.cardHelpCodes.includes(h.code)}
            onSelect={() => draft.toggleCardHelp(h.code)}
          />
        ))}
      </div>
    </section>
  )
}
